import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { OutreachDashboard } from "../components/OutreachDashboard";
import { OutreachPrograms } from "../components/OutreachPrograms";
import { OutreachCalendar } from "../components/OutreachCalendar";

export function OutreachPage() {
  return (
    <div className="space-y-6">
      <Tabs defaultValue="dashboard" className="space-y-6">
        <TabsList>
          <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
          <TabsTrigger value="programs">Programs</TabsTrigger>
          <TabsTrigger value="calendar">Calendar</TabsTrigger>
        </TabsList>

        <TabsContent value="dashboard">
          <OutreachDashboard />
        </TabsContent>

        <TabsContent value="programs">
          <OutreachPrograms />
        </TabsContent>

        <TabsContent value="calendar">
          <OutreachCalendar />
        </TabsContent>
      </Tabs>
    </div>
  );
}
